import { StepSchema } from '@feedyou-ai/feedbot-schema'

export function isAiOrLlmInvokeStep(step: StepSchema): boolean {
  return (
    step.type === 'ai' ||
    (step.type === 'integration' && step.service === 'llm' && step.action === 'invoke')
  )
}
